import * as i0 from '@angular/core';
import { Directive, Input, HostListener, NgModule } from '@angular/core';
import * as i1 from '@angular/router';

const isFullPath = (url) => {
    return url.startsWith && (url.startsWith('https') || url.startsWith('http') || url.startsWith('tel:') || url.startsWith('mailto:'));
};
class NavigationDirective {
    constructor(el, renderer, router) {
        this.el = el;
        this.renderer = renderer;
        this.router = router;
        this._url = '';
        this._target = '';
    }
    set smNavigate(url) {
        if (url === this._url) {
            return;
        }
        this._url = url;
        if (this.url) {
            this.renderer.setAttribute(this.el.nativeElement, 'href', this.url);
        }
        else {
            this.renderer.removeAttribute(this.el.nativeElement, 'href');
        }
    }
    get url() {
        return this._url;
    }
    set smNavigateTarget(target) {
        if (target === this._target) {
            return;
        }
        this._target = target === 'blank' || target === '_blank' ? '_blank' : '';
        if (this.target) {
            this.renderer.setAttribute(this.el.nativeElement, 'target', this.target);
        }
        else {
            this.renderer.removeAttribute(this.el.nativeElement, 'target');
        }
    }
    get target() {
        return this._target;
    }
    onClick(evt) {
        if (!this.url) {
            evt.preventDefault();
            return;
        }
        if (isFullPath(this.url)) {
            return;
        }
        evt.preventDefault();
        if (this.target === '_blank') {
            window.open(this.url, '_blank');
        }
        else {
            this.router.navigateByUrl(this.url);
        }
    }
}
NavigationDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: NavigationDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i1.Router }], target: i0.ɵɵFactoryTarget.Directive });
NavigationDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.6", type: NavigationDirective, selector: "[smNavigate]", inputs: { smNavigate: "smNavigate", smNavigateTarget: "smNavigateTarget" }, host: { listeners: { "click": "onClick($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: NavigationDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[smNavigate]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i1.Router }]; }, propDecorators: { smNavigate: [{
                type: Input
            }], smNavigateTarget: [{
                type: Input
            }], onClick: [{
                type: HostListener,
                args: ["click", ["$event"]]
            }] } });

class NavigationDirectiveModule {
}
NavigationDirectiveModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: NavigationDirectiveModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
NavigationDirectiveModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.6", ngImport: i0, type: NavigationDirectiveModule, declarations: [NavigationDirective], exports: [NavigationDirective] });
NavigationDirectiveModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: NavigationDirectiveModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: NavigationDirectiveModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        NavigationDirective
                    ],
                    imports: [],
                    exports: [NavigationDirective],
                    providers: [],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { NavigationDirective, NavigationDirectiveModule, isFullPath };
